<template>
  <div class="social-icons">
    <a :href="linkedInUrl" aria-label="VIZBI on LinkedIn" target="_blank" rel="noopener noreferrer">
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    </a>
    <a :href="xUrl" aria-label="VIZBI on X" target="_blank" rel="noopener noreferrer">
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.265 5.638 5.9-5.638zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    </a>
  </div>
</template>

<script setup>
const linkedInUrl = "https://www.linkedin.com/company/vizbi.org";
const xUrl = "https://x.com/vizbi";
</script>

<style scoped>
.social-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
a {
  display: flex;
  align-items: center;
  color: white;
  opacity: 1;
  transition: opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
a:hover {
  opacity: 0.65;
}
svg {
  width: 1.1rem;
  height: 1.1rem;
}
</style>
